
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(1 1)"}},[_c('path',{attrs:{"fill":"#00DCF7","fill-rule":"nonzero","d":"M15.5 15.5h6v1l-5 5h-1z"}}),_c('path',{attrs:{"stroke":"#000","d":"M20.88 17.29l-3.69 3.6a2.15 2.15 0 01-1.49.61H2.61A2.1 2.1 0 01.5 19.43V2.56A2.09 2.09 0 012.61.5h16.78a2.09 2.09 0 012.11 2.06v13.27a2 2 0 01-.62 1.46h0z"}}),_c('path',{attrs:{"stroke":"#000","d":"M21.5 15.43h-5.28a.71.71 0 00-.71.71v5.25h0"}}),_c('rect',{attrs:{"width":"16","height":"1.38","x":"3","y":"5.19","fill":"#00DCF7","fill-rule":"nonzero","rx":".34"}}),_c('rect',{attrs:{"width":"11","height":"1.38","x":"5.5","y":"7.94","fill":"#00DCF7","fill-rule":"nonzero","rx":".34"}})])])
          )
        }
      }
    